import React, { FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { ComponentProps } from './types';

export const Component: FunctionComponent<ComponentProps> = ({
  recruitments,
  isNewgrad,
  hoverIcon,
  noimage,
}) => {
  if (recruitments.length === 0) return null;

  return (
    <Presentation
      recruitments={recruitments}
      isNewgrad={isNewgrad}
      hoverIcon={hoverIcon}
      noimage={noimage}
    />
  );
};
